module.exports = __webpack_public_path__ + "img/action-sidebar-act.3def8875.svg";